import { RouteConfig } from 'vue-router';
import { PagePermissionEnum } from '@/types/enum/PermissionEnum';

const surveyCampaignRoute = [
	{
		path: '/questionnaires/:projectSurveyCampaignTokenMode',
		name: 'projectSurveyCampaignSurveyRedirect',
		component: () => import(
			/* webpackChunkName: "project_survey_campaign_redirect" */
			'../../views/patient/PatientProjetSurveyCampaign.vue'
		),
		meta: {
			hideHeader: true,
			disableNavigation: true,
			hideFooter: true
		}
	},
	{
		path: '/experience-patient',
		name: 'surveyCampaignAccessMaster',
		props: true,
		component: () => import(
			/* webpackChunkName: "survey_campaign_am" */
			'../../views/SurveyCampaignsView.vue'
			),

		meta: {
			label: 'router.label.surveyCampaign',
			subLabel: 'router.subLabel.surveyCampaignAnalytics',
			can: PagePermissionEnum.EXPERIENCE_PATIENT_ADMINISTRATION,
			hiddenOnProjectRoute: true
		}
	}
] as RouteConfig[];

export default surveyCampaignRoute;
